import {AuctionVehicleDetailResponseBody} from '@dms/api/core';

/** Published prices in display order. A private current bid is never a candidate. */
export function getSealedAuctionPrices(
  vehicle: Pick<
    AuctionVehicleDetailResponseBody['auctionVehicle'],
    'priceMinimum' | 'priceBuyNow' | 'originalPriceMinimum' | 'originalPriceBuyNow'
  >
) {
  return [
    {
      kind: 'minimum' as const,
      labelKey: 'entity.auction.labels.minimumBid' as const,
      price: vehicle.priceMinimum,
      originalPrice: vehicle.originalPriceMinimum,
    },
    {
      kind: 'buyNow' as const,
      labelKey: 'entity.auction.labels.buyNow' as const,
      price: vehicle.priceBuyNow,
      originalPrice: vehicle.originalPriceBuyNow,
    },
  ].filter((price): price is typeof price & {price: number} => (price.price ?? 0) > 0);
}
